import { render, staticRenderFns } from "./SettingsBasic.vue?vue&type=template&id=62ad78f8&scoped=true&"
import script from "./SettingsBasic.vue?vue&type=script&lang=ts&"
export * from "./SettingsBasic.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsBasic.vue?vue&type=style&index=0&id=62ad78f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ad78f8",
  null
  
)

export default component.exports